module.exports = __webpack_public_path__ + "static/media/banner2.4664278b.png";